import React, {
  ComponentType
} from 'react'
import {
  Modal,
  Table
} from 'semantic-ui-react'
import { format } from 'date-fns'
// Local
import {
  FORMAT,
  PAGES
} from '../../constant'
import {
  cursorClass,
  PatientScheduleModalTableData
} from './utils'

const SafeModal = Modal as unknown as ComponentType<any>
const SafeTable = Table as unknown as ComponentType<any>

type History = {
  push: (path: string) => void
}

type PatientScheduleModalProps = {
  history: History
  list: PatientScheduleModalTableData[] | null | undefined
  closeModal: () => void
}

type TableData = {
  id: string
  reasonDescription: string
  time: string
  mobileTime: string
  meta: {
    className: string
  }
}

/** Prepare encounter data for display in modal */
const generateTableData = (
  list: PatientScheduleModalTableData[]
): TableData[] => list.map(record => ({
  id: record.id,
  reasonDescription: record.reasonDescription,
  time: format(
    record.start,
    FORMAT.DATE_TIME
  ),
  mobileTime: format(
    record.start,
    FORMAT.DATE
  ),
  meta: {
    className: cursorClass
  }
}))

/** Display a set of encounters for a specific patient in modal */
function PatientScheduleModal(props: PatientScheduleModalProps): JSX.Element {
  const {
    history,
    list,
    closeModal
  } = props

  /** Open the selected encounter */
  function selectEncounter(id: string): void {
    history.push(PAGES.ENCOUNTER_DETAIL + id)
  }

  if (!list) {
    return <></>
  }

  return (
    <SafeModal
      closeIcon
      centered={ false }
      open={ true }
      onClose={ closeModal }
    >
      <Modal.Content>
        <div>
          <SafeTable
            computerColumns={ [
              {
                name: 'Time',
                value: 'time'
              },
              {
                name: 'Reason for Visit',
                value: 'reasonDescription'
              }
            ] }
            mobileColumns={ [
              {
                value: 'mobileTime',
                width: '4'
              },
              {
                value: 'reasonDescription',
                width: '12'
              }
            ] }
            data={ generateTableData(list) }
            onClick={ selectEncounter }
          />
        </div>
      </Modal.Content>
    </SafeModal>
  )
}

export default PatientScheduleModal
